import { apiRequest } from "@alba-cars/common-modules";

import { PaginatedResponse } from "@/components/common/forms/FormAutoComplete";

export interface DealDriveModel {
  id: number;
  name: string;
  brandId: number;
}

export const getDealDriveModels = async (brandId: string | number, search?: string) => {
  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append("search", search);
  }

  const response = await apiRequest<DealDriveModel[]>(
    `/dealdrive/brands/${brandId}/models${search ? `?${queryParams.toString()}` : ""}`,
    {
      next: {
        revalidate: 3600, // Cache for 1 hour
        tags: [`dealdrive-models-${brandId}`],
      },
    },
  );

  return response;
};

export const getDealDriveModelsPaginated = async (
  inputValue: string,
  _page?: number,
  filter?: Record<string, string>,
): Promise<PaginatedResponse<{ label: string; value: string }>> => {
  try {
    // Check if we have a brandId in the filter
    if (!filter?.brandId) {
      return {
        data: [],
        meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
      };
    }

    const models = await getDealDriveModels(filter.brandId, inputValue);

    const formattedModels = models.map((model) => ({
      label: model.name,
      value: model.id.toString(),
    }));

    return {
      data: formattedModels,
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  } catch (error) {
    console.error("Error fetching DealDrive models:", error);
    return {
      data: [],
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  }
};
